function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M22.265 3.844c6.747 5.466 10.976 7.727 19.175 10.58 0 0 0 32.398-19.175 32.398S3.09 14.423 3.09 14.423c8.417-2.61 12.554-5.027 19.175-10.58z",
  stroke: "#1FA956",
  strokeWidth: 4.5,
  strokeLinecap: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.668 28.97l5.29 5.29 13.224-13.225",
  stroke: "#1FA956",
  strokeWidth: 4.5,
  strokeLinecap: "round"
});

function SvgImgDataSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDQiIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCA0NCA1MCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyLjI2NSAzLjg0Mzc1QzI5LjAxMTkgOS4zMDk4NSAzMy4yNDEyIDExLjU3MDcgNDEuNDQwMSAxNC40MjMxQzQxLjQ0MDEgMTQuNDIzMSA0MS40NDAxIDQ2LjgyMjUgMjIuMjY1IDQ2LjgyMjVDMy4wODk4NCA0Ni44MjI1IDMuMDg5ODQgMTQuNDIzMSAzLjA4OTg0IDE0LjQyMzFDMTEuNTA3MyAxMS44MTM5IDE1LjY0NCA5LjM5NjQ0IDIyLjI2NSAzLjg0Mzc1WiIgc3Ryb2tlPSIjMUZBOTU2IiBzdHJva2Utd2lkdGg9IjQuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIi8+CjxwYXRoIGQ9Ik0xMy42NjggMjguOTY5N0wxOC45NTc3IDM0LjI1OTRMMzIuMTgxOSAyMS4wMzUyIiBzdHJva2U9IiMxRkE5NTYiIHN0cm9rZS13aWR0aD0iNC41IiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgImgDataSecurity as ReactComponent };